import axios from "axios";
import setupInterceptors from "../api/interceptors";

let instance = axios.create({
  baseURL: "/api/",
});

setupInterceptors(instance);

export default instance;
